module.exports = __webpack_public_path__ + "img/dash-square-dotted.a13f3fe9.svg";